exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_companyInformation_JPft1onq0dOJKUGwO7WS5 {\n  width: 100%;\n  margin-bottom: 20px;\n  float: left;\n}\n\n.IA_divider_2xjRyxZx2eeU1t0bVZD5qz, .IA_dividerDarkMode_1KD8_9SbayLoKj7zjYtsDK {\n  height: 1px;\n  width: 100%;\n  background-color: #eeeeee;\n  margin-top: 40px;\n  margin-bottom: 20px;\n  float: left;\n}\n\n.IA_billingInfo_1b-Iy8ZkVWNhzwLYz1f7Ob {\n  font-size: 14px;\n}", ""]);

// Exports
exports.locals = {
	"IA_companyInformation": "IA_companyInformation_JPft1onq0dOJKUGwO7WS5",
	"IA_divider": "IA_divider_2xjRyxZx2eeU1t0bVZD5qz",
	"IA_dividerDarkMode": "IA_dividerDarkMode_1KD8_9SbayLoKj7zjYtsDK",
	"IA_billingInfo": "IA_billingInfo_1b-Iy8ZkVWNhzwLYz1f7Ob"
};